import { useTranslation, Trans } from "react-i18next";

import benefits from '../../img/partner/partner.png'

function Benefits () {

    const { t } = useTranslation();

    return(
        <div className="overflow-hidden relative z-50">
            <div className="w-full h-[40px] xl:h-[60px] bg-[#131313]"></div>
            <div className="w-full h-[40px] xl:h-[60px] rounded-t-[40px] xl:rounded-t-[60px] bg-white mt-[-40px] xl:mt-[-60px]"></div>
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto mt-[60px] xl:mt-[80px]">
               <div className="flex flex-col xl:flex-row justify-between"> 
                    <div className="xl:mt-[25px]">
                        <p className="xl:max-w-[553px] manrope text-[24px] xl:text-[48px] font-[500] leading-[1.2]">{t('partner.3')}</p>
                        <div className="flex gap-[12px] xl:gap-[22px] mt-[40px]">
                            <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <circle cx="3" cy="3" r="3" fill="black"/>
                            </svg>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px] xl:max-w-[467px]">{t('partner.4')}</p>
                        </div>
                        <div className="flex gap-[12px] xl:gap-[22px] mt-[12px]">
                            <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <circle cx="3" cy="3" r="3" fill="black"/>
                            </svg>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px]">{t('partner.5')}</p>
                        </div>
                        <div className="flex gap-[12px] xl:gap-[22px] mt-[12px]">
                            <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <circle cx="3" cy="3" r="3" fill="black"/>
                            </svg>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px] xl:max-w-[467px]">{t('partner.6')}</p>
                        </div>
                        <div className="flex gap-[12px] xl:gap-[22px] mt-[12px]">
                            <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <circle cx="3" cy="3" r="3" fill="black"/>
                            </svg>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px] xl:max-w-[467px]">{t('partner.7')}</p>
                        </div>
                        <div className="flex gap-[12px] xl:gap-[22px] mt-[12px]">
                            <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <circle cx="3" cy="3" r="3" fill="black"/>
                            </svg>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px] xl:max-w-[467px]">{t('partner.8')}</p>
                        </div>
                        <div className="flex gap-[12px] xl:gap-[22px] mt-[12px]">
                            <svg className="mt-[8px] flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
                                <circle cx="3" cy="3" r="3" fill="black"/>
                            </svg>
                            <p className="text-[#000000B2] roboto text-[14px] xl:text-[16px] xl:max-w-[467px]">{t('partner.9')}</p>
                        </div>
                    </div> 
                    <img src={benefits} alt="" className="mt-[40px] xl:mt-0"/>
               </div>
            </div>      
        </div>
    );
}

export default Benefits;